import React from "react";
import { ArrowLeft } from "lucide-react";
import Logo from "../../components/common/Logo";
import howToUseData from "../../data/howtouse.json";


 function HowtoUse() {
    return (
        <>
        <div className="min-h-screen bg-[#F4EFE8] px-4 md:px-10 py-6">
            {/* LOGO */}
            <div className="mb-8">
                <Logo />
            </div>

            {/* TOP BAR */}
            <div className="bg-primary rounded-md h-[70px] flex items-center justify-between px-6 md:px-8">

                <h2 className="text-white text-[24px] md:text-[40px] font-semibold">
                    How to use platform
                </h2>

                <button>
                    <ArrowLeft
                        size={40}
                        className="text-white"
                    />
                </button>

            </div>
            {/* CONTENT */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-10">

                {/* LEFT */}
                <div className="mt-18">

                    <h3 className="text-primary text-2xl underline mb-8">
                        How to use platform
                    </h3>

                    <video
                        controls
                        className="w-full rounded-lg"
                    >
                        <source
                            src="https://www.w3schools.com/html/mov_bbb.mp4"
                            type="video/mp4"
                        />
                    </video>

                </div>

                {/* RIGHT */}
                <div className="mt-10">

                    <h2 className="text-primary text-3xl font-semibold mb-8">
                        Steps to use our platform:
                    </h2>

                    <ol className="list-decimal pl-6 space-y-4 text-[20px]">

                        {howToUseData.map((item) => (
                            <li key={item.id}>
                                {item.step}
                            </li>
                        ))}

                    </ol>

                </div>

        </div>
       </div>
        </>
    )
}
export default HowtoUse;